var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"settings__nav"},_vm._l((_vm.menus),function(v,i){return _c('div',{key:i,staticClass:"settings__nav-item",class:{ active: _vm.step === v.step },on:{"click":function($event){return _vm.$emit('on-change-step', v.step)}}},[_c('span',{staticClass:"settings__nav-item-text"},[_vm._v(_vm._s(_vm.getTranslatedText(v.title)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }